





























































































































































































import Vue, { VueConstructor } from "vue";
import VaSwitch from "@/components/atoms/VaSwitch.vue";
import validationMixin from "@/components/mixins/validationMixin";
import policiesMixin from "@/components/mixins/policiesMixin";
import { FieldValues } from "@/models/policy";
import FileUploader from "@/components/shared/FileUploader.vue";
import { FileFormatted } from "@/models/file";
import VaTextField from "@/components/atoms/VaTextField.vue";

export default (
  Vue as VueConstructor<
    Vue &
      InstanceType<typeof policiesMixin> &
      InstanceType<typeof validationMixin>
  >
).extend({
  name: "HomeLauncherConfiguration",
  components: { VaTextField, FileUploader, VaSwitch },
  mixins: [validationMixin, policiesMixin],
  data() {
    return {
      fields: {} as { [key: string]: FieldValues },
    };
  },
  methods: {
    uploadWorkspaceBackground(background: FileFormatted) {
      this.fields.WorkspaceBackground = background;
      this.onChange();
    },
  },
});
